import React, { useEffect, useState } from "react";
import {
  TextField,
  Select,
  MenuItem,
  Button,
  InputLabel,
  FormControl,
  Grid,
  FormControlLabel,
  Checkbox,
  Box,
  Chip,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Stepper from "react-stepper-horizontal";
import { Field } from "formik";
import CustomPopover from "../../../Popover/Popover";

const Step2 = (props) => {
  const sports = ["Course à pied", "Trail", "VTT"];

  useEffect(() => {
    window.scrollTo(0, 0);
    if (!props.state.chips) {
      props.setState("chips", []);
    }
  }, []);

  const handleChange = (key, value) => {
    props.setFormState({ ...props.formState, [key]: value });
  };

  const handleChangeRegisterFormat = (key, value) => {
    if (value === "free") {
      // On reset l'attribut "price" du state, si jamais l'user saisit un prix et switch à gratuit
      handleChange("price", "");
    }
    handleChange(key, value);
  };

  return (
    <div>
      <div>
        <Stepper
          titleFontSize={12}
          steps={[
            { title: "Application" },
            { title: "Inscription" },
            { title: "Course" },
          ]}
          activeStep={1}
        />
      </div>
      <h2>Configuration du formulaire d'inscription</h2>
      <h4>
        <i>
          "Pour s'inscrire mon coureur devra saisir les informations suivantes"
          :
        </i>
      </h4>

      <Grid container spacing={2}>
        <Grid item xs={12} className="GridSelectRegisterInput">
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formLastName ? true : false}
                name="formLastName"
                color="primary"
              />
            }
            label="Nom"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) =>
                  props.setFormState({
                    ...props.formState,
                    [e.target.name]: e.target.checked,
                  })
                }
                checked={props.formState.formFirstName ? true : false}
                name="formFirstName"
                color="primary"
              />
            }
            label="Prénom"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formGender ? true : false}
                name="formGender"
                color="primary"
              />
            }
            label="Sexe"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formBirthDate ? true : false}
                name="formBirthDate"
                color="primary"
              />
            }
            label="Date de naissance"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formEmail ? true : false}
                name="formEmail"
                color="primary"
              />
            }
            label="Adresse mail"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formPhone ? true : false}
                name="formPhone"
                color="primary"
              />
            }
            label="Téléphone"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formAddress ? true : false}
                name="formAddress"
                color="primary"
              />
            }
            label="Adresse"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formPostalCode ? true : false}
                name="formPostalCode"
                color="primary"
              />
            }
            label="Code postal"
          />
          <FormControlLabel
            control={
              <Checkbox
                onChange={(e) => handleChange(e.target.name, e.target.checked)}
                checked={props.formState.formCity ? true : false}
                name="formCity"
                color="primary"
              />
            }
            label="Ville"
          />
        </Grid>
        <Grid className="GridSelectChallenge" item xs={12} md={6}>
          <Box mb={1}>
            <div className="popover">
              <h4>Challenges souhaités :</h4>
              <CustomPopover>
                Inclus dans l'application : les classements individuels
                scratchs, par catégorie, par sexe sont accessibles par défaut.
                Nous vous ajoutons un classement individuel général (regroupant
                toutes vos courses) pour classer vos coureurs suivant leur
                nombre d'activité et le nombre de kilomètre parcourus. Ces
                classements permet à tous d'être premier !
              </CustomPopover>
            </div>
            <i style={{ fontSize: "14px", textAlign: "justify" }}>
              Classement de base: Scratch / Sexe / Catégorie <br />/ Nombre de
              km / Nombre d'activités / Temps
              <br />
              Je souhaite le(s) classement(s) par équipe <br /> suivant(s) :
            </i>
          </Box>
          <FormControl>
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) =>
                    handleChange(e.target.name, e.target.checked)
                  }
                  checked={props.formState.challengeEntreprise ? true : false}
                  name="challengeEntreprise"
                  color="primary"
                />
              }
              label="Entreprise"
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) =>
                    handleChange(e.target.name, e.target.checked)
                  }
                  checked={props.formState.challengeClub ? true : false}
                  name="challengeClub"
                  color="primary"
                />
              }
              label="Club"
            />
            <FormControlLabel
              control={
                <Checkbox
                  onChange={(e) =>
                    handleChange(e.target.name, e.target.checked)
                  }
                  checked={props.formState.challengeFamille ? true : false}
                  name="challengeFamille"
                  color="primary"
                />
              }
              label="Famille"
            />
            <Grid container spacing={2}>
              <Grid className="GridSelectChallenge" item xs={6}>
                <FormControlLabel
                  control={
                    <Checkbox
                      onChange={(e) =>
                        handleChange(e.target.name, e.target.checked)
                      }
                      checked={props.formState.otherChallenge ? true : false}
                      name="otherChallenge"
                      color="primary"
                    />
                  }
                  label="Autre challenge"
                />
              </Grid>
              <Grid className="GridSelectChallenge" item xs={8} md={12}>
                <TextField
                  my="auto"
                  disabled={!props.formState.otherChallenge ? true : false}
                  onChange={(e) => handleChange(e.target.name, e.target.value)}
                  name="otherChallengeInput"
                  label="Saisir un challenge personnalisé"
                />
              </Grid>
            </Grid>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={6}>
          <h4>Sports pratiqués:</h4>{" "}
          <Autocomplete
            multiple
            id="tags-outlined"
            options={sports.map((option) => option)}
            freeSolo
            defaultValue={props.formState.chips}
            onChange={(e, newVal) => {
              props.setFormState({ ...props.formState, chips: newVal });
            }}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  variant="standart"
                  label={option}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => (
              <TextField
                {...params}
                variant="standard"
                label="Sports *"
                placeholder="Saisir un sport"
              />
            )}
          />
          <p style={{ fontSize: "11px", color: "gray" }}>
            Saisir un sport et appuyer sur entrée
          </p>
          <h4 className="registerFormat">
            <p>Séléctionnez le prix de l'inscription :</p>
          </h4>
          <Grid item xs={12} md={9}>
            <FormControl className="formcontrol-select">
              <InputLabel>Format d'inscription</InputLabel>
              <Select
                onChange={(e) =>
                  handleChangeRegisterFormat(e.target.name, e.target.value)
                }
                displayEmpty
                inputProps={{ "aria-label": "Without label" }}
                name="registerFormat"
                value={props.formState.registerFormat || ""}
              >
                <MenuItem value="free">Gratuit</MenuItem>
                <MenuItem value="paid">Prix unique</MenuItem>
                <MenuItem value="donation">Don</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={12} md={9}>
            <Field name="price">
              {({ field, form, meta }) => (
                <TextField
                  label="Montant"
                  type="number"
                  value={props.formState.price}
                  disabled={
                    props.formState.registerFormat === "free" ||
                    !props.formState.registerFormat
                      ? true
                      : false
                  }
                  InputProps={{
                    endAdornment: <div>€</div>,
                  }}
                  {...field}
                  error={
                    meta.touched &&
                    meta.error &&
                    props.formState.registerFormat !== "free"
                  }
                  helperText={
                    meta.touched &&
                    meta.error &&
                    props.formState.registerFormat !== "free"
                      ? meta.error
                      : ""
                  }
                />
              )}
            </Field>
          </Grid>
        </Grid>

        <Grid container justify="flex-end">
          <Box my={2}>
            {props.hasPrev() && (
              <Button
                className="bottom-button"
                size="small"
                onClick={props.prev}
                variant="outlined"
                color="primary"
              >
                Précédent
              </Button>
            )}
            {props.hasNext() && (
              <Button
                disabled={!props.formState.chips.length > 0}
                className="bottom-button"
                size="small"
                onClick={props.next}
                variant="contained"
                color="primary"
              >
                Suivant
              </Button>
            )}
          </Box>
        </Grid>
        <i style={{ opacity: "0.6", fontSize: "12px" }}>* Champ Obligatoire</i>
      </Grid>
    </div>
  );
};

export default Step2;
